import React, { useState } from 'react';
import flowerbg from '../../assets/flowerbg.png';
import logo from '../../assets/logo.png';
import CheckMail from './CheckMail';
import ForgotPassword from './ForgotPassword';
import Login from './Login';
import Register from './Register';
import ResetSuccess from './ResetSuccess';
import SetNewPassword from './SetNewPassword';

const Auth = () => {
  const [authType, setAuthType] = useState('register');
  const authTypeHandler = (authType) => {
    switch (authType) {
      case 'register':
        return <Register setAuthType={setAuthType} />;
      case 'login':
        return <Login setAuthType={setAuthType} />;
      case 'forgotpassword':
        return <ForgotPassword setAuthType={setAuthType} />;
      case 'checkmail':
        return <CheckMail setAuthType={setAuthType} />;
      case 'setnewpassword':
        return <SetNewPassword setAuthType={setAuthType} />;
      case 'resetsuccess':
        return <ResetSuccess setAuthType={setAuthType} />;
      default:
        return <></>;
    }
  };
  return (
    <div className="flex flex-col h-screen w-full bg-blue-100 justify-center items-center">
      <div className="w-[500px] flex flex-col justify-center items-center ">
        {authTypeHandler(authType)}
      </div>

      {/* <div className="flex-1 bg-[#EEE9E2] md:block hidden">
        <img
          className="w-full h-full object-contain"
          src={flowerbg}
          alt="Floral Background"
        />
      </div> */}
    </div>
  );
};

export default Auth;
